import { call, put, debounce } from 'redux-saga/effects';

import { itineraryRequest, itinerarySuccess, itineraryFailure } from '../../slices/cruise';
import axios from '../axiosConfig';

function* itineraryWorker(action) {
  try {
    const itineraryId = action.payload;
    const config = {
      method: 'get',
      url: `cruises/getItineraryDetails?itineraryId=${itineraryId}`,
    };
    const response = yield call(axios, config);
    if (response.data) {
      yield put(itinerarySuccess(response.data));
    } else throw new Error();
  } catch (error) {
    let errorMsg = 'Could not find itinerary details';
    if (error && error.response) {
      errorMsg = `${error.response.data.title || ''} ${error.response.data.detail || ''}`.trim();
    }
    yield put(itineraryFailure({ error: errorMsg }));
  }
}

function* itineraryWatcher() {
  yield debounce(50, itineraryRequest.toString(), itineraryWorker);
}

export default itineraryWatcher;
